import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Invoice } from '../../invoice.model';
import { InvoicesDataProvider } from '../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { finalize } from 'rxjs/operators';
import { MessageService } from '../../../../../../shared/services/helpers/message-service/message.service';

@Component({
	selector: 'delete-invoice-modal',
	template: require('./delete-invoice-modal.html')
})
export class DeleteInvoiceModalComponent {
	@Input() invoice: Invoice;
	@Output() updateParent: EventEmitter<boolean> = new EventEmitter();

	buttonDisabled: boolean;
	isDeleteInvoiceSpinnningWheelActive: boolean;

	constructor(
		private invoicesDataService: InvoicesDataProvider,
		private messageService: MessageService
	) {}

	deleteInvoice(invoiceId): void {
		this.isDeleteInvoiceSpinnningWheelActive = true;
		this.buttonDisabled = true;

		invoiceId = invoiceId || null;
		this.invoicesDataService
			.deleteInvoice(invoiceId)
			.pipe(finalize(() => (this.isDeleteInvoiceSpinnningWheelActive = false)))
			.finally(() => (this.buttonDisabled = false))
			.subscribe(
				data => this.successDeleteInvoice(data),
				error => {
					this.errorDeleteInvoice(error);
				}
			);
	}

	private successDeleteInvoice(data): void {
		if (data) {
			if (data.errorMessage) {
				this.messageService.showToaster('e_0', 'payments');
				$('#deleteModal').modal('hide');
				return;
			}
			this.messageService.showToaster('s_8', 'payments');
			$('#deleteModal').modal('hide');
		}
		this.updateParent.emit(true);
	}

	private errorDeleteInvoice({ status, data }): void {
		const errorMessage = data.errorMessage;
		let errorCode, errorPlace, value;

		if (status >= 400 && status < 500 && errorMessage) {
			if (
				errorMessage.includes(
					'This payment cannot be marked as unpaid because it was overpaid in Xero.'
				)
			) {
				errorCode = 'e_12';
				errorPlace = 'xero';
				value = 'invoice';
			} else if (
				errorMessage.includes(
					'Xero access token expired, reconnect Xero please'
				) ||
				errorMessage.includes(
					'Bummer! Xero access token not authorized or revoked, reconnect Xero please'
				) ||
				errorMessage.includes(
					'Bummer! Xero access token revoked, reconnect Xero please'
				)
			) {
				errorCode = 'e_14';
				errorPlace = 'xero';
			} else if (
				errorMessage.includes(
					"Bummer! You don't have an active Xero subscription."
				)
			) {
				errorCode = 'e_15';
				errorPlace = 'xero';
			} else {
				errorCode = 'e_2';
				errorPlace = 'general';
				value = errorMessage;
			}
		} else {
			errorCode = 'e_0';
			errorPlace = 'general';
		}
		this.messageService.showToaster(errorCode, errorPlace, value);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/invoices/modals/delete-invoice-modal/delete-invoice-modal.ts